<template>
  <div class="cotainer">
    <div class="content">
      <Logo />
      <div class="message" v-if="$route.query.next">
        You must be logged in to access this page.
      </div>
      <form class="form">
        <div class="form-error" v-if="errors.non_field_errors.length">
          <p v-for="error in errors.non_field_errors" :key="error">
            {{ error }}
          </p>
        </div>
        <div class="form-input">
          <input type="text" v-model="email" placeholder="E-mail address" />
          <span v-if="errors.field_errors.email">{{
            errors.field_errors.email
          }}</span>
        </div>
        <div class="form-input">
          <input type="password" v-model="password" placeholder="Password" />
          <span v-if="errors.field_errors.password">{{
            errors.field_errors.password
          }}</span>
        </div>
        <button @click="loginUser" id="login-button">Login</button>
      </form>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import Logo from "@/components/Logo.vue";

export default {
  components: {
    Logo,
  },
  data: () => ({
    email: "",
    password: "",
    errors: {
      field_errors: {},
      non_field_errors: [],
    },
  }),
  methods: {
    ...mapActions({ doLogin: "auth/doLogin" }),
    async loginUser(e) {
      e.preventDefault();
      this.errors = {
        field_errors: {},
        non_field_errors: [],
      };

      // doLogin
      let credentials = {
        email: this.email,
        password: this.password,
      };
      let resp = await this.doLogin(credentials);
      if (resp.success) {
        this.$router.push(this.$route.query.next || { name: "LandingPage" });
      } else {
        console.log("RESP ERROR");
        if (resp.field_errors) {
          this.errors.field_errors = resp.field_errors;
        }
        if (resp.non_field_errors) {
          this.errors.non_field_errors = resp.non_field_errors;
        }
      }
    },
  },
};
</script>
<style lang="less" scoped>
.message {
  background: white;
  border-radius: 3px;
  padding: 12px;
  color: black;
  box-shadow: 2px 2px 5px #00000044;
}

.content {
  display: flex;
  align-items: center;
  flex-direction: column;
  color: white;
  font-weight: 300;
  text-align: center;


  svg {
    margin-bottom: 2rem;
  }

  ::-webkit-input-placeholder {
    /* WebKit browsers */
    font-family: "Source Sans Pro", sans-serif;
    color: white;
    font-weight: 300;
  }
  :-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    font-family: "Source Sans Pro", sans-serif;
    color: white;
    opacity: 1;
    font-weight: 300;
  }
  ::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    font-family: "Source Sans Pro", sans-serif;
    color: white;
    opacity: 1;
    font-weight: 300;
  }
  :-ms-input-placeholder {
    /* Internet Explorer 10+ */
    font-family: "Source Sans Pro", sans-serif;
    color: white;
    font-weight: 300;
  }
}

@prim: #53e3a6;

form {
  padding: 20px 0;
  position: relative;
  z-index: 2;

  div.form-input {
    margin: 24px;
  }

  input {
    display: block;
    appearance: none;
    outline: 0;
    border: 1px solid fade(white, 40%);
    background-color: fade(white, 20%);
    width: 250px;

    border-radius: 3px;
    padding: 10px 15px;
    margin: 0 auto 10px auto;
    display: block;
    text-align: center;
    font-size: 18px;

    color: white;

    transition-duration: 0.25s;
    font-weight: 300;

    &:hover {
      background-color: fade(white, 40%);
    }

    &:focus {
      background-color: white;
      width: 300px;

      color: black;
    }
  }

  button {
    appearance: none;
    outline: 0;
    background-color: white;
    border: 0;
    padding: 10px 15px;
    color: @prim;
    border-radius: 3px;
    width: 250px;
    cursor: pointer;
    font-size: 18px;
    transition-duration: 0.25s;

    &:hover {
      background-color: rgb(245, 247, 249);
    }
  }
}
</style>
